import { PARAM_TYPE_MAP, PARAM_TYPE_VALUE_MAP } from "../../utils/lists";
import { isNumber } from "@bonusmap/shared_ui/library";
import { InputParamItem } from "./bap-types";
import { BlockAnalyzed } from "./block-analyzed";
import { BapGroup } from "./bap-group";
import { BapGroups } from "./bap-groups";
import { ApiResponse, ParamDefRowNoId, ParamType, ParamTypeName, ParamTypeValue } from "@bonusmap/api-types";
import { toastError, toastSuccess } from "../../toasts";
/**
 * Blocco per mostrare un gruppo di parametri
 */
export class BapParam extends BlockAnalyzed {
    static override webComponentName: string = "bap-param";
    protected override _templateId: string = "bap-param";
    constructor() {
        super();
    }
    private _index: number = -1;
    public get index(): number {
        if (this._index === -1) {
            const attr = this.getAttribute('index');
            if (attr) {
                const idx = parseInt(attr);
                if (!isNaN(idx) && idx >= 0) {
                    this._index = idx;
                }
            }
        }
        return this._index;
    }
    private _bapGroups!: BapGroups;
    get bapGroups(): BapGroups {
        if (!this._bapGroups) {
            this._bapGroups = this.closest('bap-groups') as BapGroups;
        }
        return this._bapGroups;
    }
    private _bapGroup!: BapGroup;
    get bapGroup(): BapGroup {
        if (!this._bapGroup) {
            this._bapGroup = this.closest('bap-group') as BapGroup;
        }
        return this._bapGroup;
    }
    private _value!: InputParamItem;
    public get value(): InputParamItem {
        if (!this._value && isNumber(this.index) && this.bapGroup.value) {
            this._value = this.bapGroup.value[this.index];
        }
        return this._value;
    }
    public set value(value: InputParamItem) {
        this._value = value;
    }
    private getTypeDisplayName(typeValue: string): string {
        const typeMap = PARAM_TYPE_MAP;
        return typeMap[typeValue] || typeValue;
    }
    private getTypeValueDisplayName(typeValue: string): string {
        const typeValueMap = PARAM_TYPE_VALUE_MAP;
        return typeValueMap[typeValue] || typeValue;
    }
    private adoptExistingParameter(parameter_id: number | string) {
        this.value.parameter_id = typeof parameter_id === "number" ? parameter_id as number : parseInt(parameter_id as string);
        console.log("Adopted parameter_id", this.value.parameter_id, this.value);
        this.bapGroups.rebuild();
    }
    protected setupEventHandlers(): void {
        super.setupEventHandlers();
        this.on('click', `[role="delete"]`, (e: Event) => {
            e.preventDefault();
            this.bapGroups.removeParam(this);
        });
        this.on('click', `[data-adopt]`, (e: Event) => {
            e.preventDefault();
            const target = e.target as HTMLElement;
            const parameter_id = target.dataset.adopt;
            this.adoptExistingParameter(parameter_id);
        });

    }
    protected afterRender(): void {
        super.afterRender();
        // const collapsers = this.querySelectorAll('.collapse');
        // const toolItems = this.querySelectorAll('.tool-item');
        // collapsers.forEach((collapser) => {
        //     // const collapseInstance = (window as any).bootstrap.Collapse.getOrCreateInstance(collapser);
        //     collapser.addEventListener('show.bs.collapse', (e: Event) => {
        //         const target = e.target as HTMLElement;
        //         const parentTool = target.closest('.tool-item');
        //         toolItems.forEach((item) => item.classList.add('d-none'));
        //         if (parentTool) {
        //             parentTool.classList.remove('d-none');
        //         }
        //     });
        //     collapser.addEventListener('hide.bs.collapse', (e: Event) => {
        //         toolItems.forEach((item) => item.classList.remove('d-none'));
        //     });
        // });
        const form = this.querySelector('form[role="create"]') as HTMLFormElement;
        if (form) {
            form.addEventListener('submit', async (e: Event) => {
                e.preventDefault();
                const formData = new FormData(form);
                const name = formData.get('name') as string;
                const summary = formData.get('summary') as string;
                const type = formData.get('type') as string;
                const typeValue = formData.get('typeValue') as string;
                const payload: ParamDefRowNoId = {
                    name: name,
                    description: summary || '',
                    type_name: type as ParamTypeName,
                    type_value: typeValue as ParamTypeValue,
                    attribute_id: null,
                    organization_id: this.user?.organization_id || 1,
                    is_core: false,
                    parameter_data: {
                        name: name,
                        description: summary || '',
                        "attribute_id": null,
                        type_name: type as ParamTypeName,
                        type_value: typeValue as ParamTypeValue,
                    }
                }
                const response: ApiResponse = await window.api.manager.params.add(payload);
                if (response.success && response.data) {
                    this.value.parameter_id = response.data.id;
                    this.bapGroups.rebuild();
                    toastSuccess("Parametro creato con successo");
                }
                else {
                    toastError(`Errore nella creazione del parametro: ${response.error || 'Errore sconosciuto'}`);
                    console.log(response.error);
                }
            });
        }
        else {
            console.warn("No form found in bap-param");
        }
    }
    protected buildRenderingData(): Record<string, any> {
        const baseData = super.buildRenderingData();
        return {
            ...baseData,
            param: this.value || null,
            getTypeDisplayName: this.getTypeDisplayName,
            getTypeValueDisplayName: this.getTypeValueDisplayName,
            componentId: this.createRandomId(),
            randId: this.createRandomId
        };
    }
} 